import { getLocalizedMessage, showMessageAlert } from '@/core/shared'
import { copyComponent, deleteComponent, updateElementIndex } from '@/core/item_assistance/creatingNewComponents'
import { attributeChangesRegister } from '@/core/item_assistance/unsavedDataManager'
import { attributeLabel } from '@/mixins/attributeLabel'

export function bindImageAttributeEvents (attribute, context) {
	var attributeArea = attribute + '__area'
	if ($('#' + attributeArea).length > 0) {
		var imageNamesArea = attribute + '__image-name__area'
		$('#' + attributeArea).find('.button_plus').click(function () {
			selectImage(attributeArea)
		})

		var imgUploader = $('#' + attributeArea).find('.image-uploader')
		$(imgUploader).change(function () {
			processImageFiles(this.files, imageNamesArea, attribute, context)
			$(imgUploader).wrap('<form>').closest('form').get(0).reset()
			$(imgUploader).unwrap()
		})

		var dropImageZone = document.getElementById(attribute + '__drop-zone')
		dropImageZone.addEventListener('dragover', handleDragOver, false)
		dropImageZone.addEventListener('drop', handleDrop, false)
		dropImageZone.addEventListener('dragenter', handleDragEnter, false)
		dropImageZone.addEventListener('dragleave', handleDragLeave, false)

		$('#' + attributeArea).find('.image-attribute').removeAttr('style')
	}

	function handleDrop (e) {
		e.stopPropagation()
		e.preventDefault()
		$('#' + attribute + '__drop-zone').removeClass('active-drop-zone')
		processImageFiles(e.dataTransfer.files, imageNamesArea, attribute, context)
	}

	function handleDragOver (e) {
		e.stopPropagation()
		e.preventDefault()
		e.dataTransfer.dropEffect = 'copy'
	}

	function handleDragEnter () {
		$('#' + attribute + '__drop-zone').addClass('active-drop-zone')
	}

	function handleDragLeave () {
		$('#' + attribute + '__drop-zone').removeClass('active-drop-zone')
	}
}

function selectImage (attributeArea) {
	$('#' + attributeArea).find('.image-uploader').click()
}

function processImageFiles (files, imageNamesArea, attribute, context) {
	if (files) {
		_.each(files, function (file) {
			var maxCount = parseInt($('#' + attribute + '__area').attr('max-count'), 10)
			var imagesCount = 0
			var imageArea = $('#' + attribute + '__image__area .row')
			if (imageArea.children().children().length > 0) {
				imagesCount = imageArea.children().length
			}
			var imageNameArea = $('#' + attribute + '__image-name__area .row')
			var imageNamesCount = imageNameArea.children().length
			if (imageNameArea.find('.hidden-element')[0]) {
				imageNamesCount--
			}
			if (imagesCount + imageNamesCount < maxCount || maxCount === -1) {
				var error = ''

				if (file.size / 1024 / 1024 > 20) {
					error = getLocalizedMessage('file.size.exceeds.20.mb')
				}

				if (error) {
					addUploadError(attribute, file.name, error)
				} else {
					createImageName(imageNamesArea, attribute, file, context)
				}
			} else {
				showMessageAlert(getLocalizedMessage('error'), 'warning', getLocalizedMessage('has.reached.the.maximum.number.of.images.for.this.attribute'))
				return false
			}
		})
	}
}

function checkImageOnLoaded (imageNamesArea, readedImage) {
	var check = false
	$('#' + imageNamesArea).find('img.loaded-image').each(function (index, element) {
		if ($(element).attr('src') == readedImage) {
			check = true
			return false
		}
	})
	return check
}

function createImageName (imageNamesArea, attribute, file, context) {
	var reader = new FileReader()
	reader.onload = function () {
		if (!checkImageOnLoaded(imageNamesArea, reader.result)) {
			var imageUploader = new ImageUploader(file, reader.result, context)
			imageUploader.loadImageToken()
		}
	}
	reader.readAsDataURL(file)
}

export function Progress (target) {
	var progress = $(target).find('progress')
	progress.show()

	progress.attr({
		value: 0,
		max: 0
	})
	$(target).find('.progress-percent').text('0%')

	this.progressHandlingFunction = function (e) {
		$(target).find('progress').attr({
			value: e.loaded,
			max: e.total
		})
		$(target).find('.progress-percent').text((e.loaded / e.total * 100).toFixed() + '%')
	}

	this.bindCancelButton = function (xhr, selector, additionalActions) {
		$(target).find(selector).click(function () {
			xhr.abort()
			if (additionalActions) {
				additionalActions()
			}
		})

	}

	this.deleteProgress = function () {
		progress.hide()
	}
}

function ImageUploader (file, readedImage, context) {
	this.loadImageToken = function () {
		var data = new FormData()
		data.append('source', file)

		var progress = new Progress($('.image_container_' + context.attributeName))
		var xhr = $.ajaxSettings.xhr()

		$.ajax({
			type: 'POST',
			url: window.urlContext + 'attachment',
			data: data,
			cache: false,
			contentType: false,
			processData: false,
			context: this,

			xhr: function () {
				xhr.upload.addEventListener('progress', progress.progressHandlingFunction, false)
				return xhr
			},

			beforeSend: function () {
				progress.bindCancelButton(xhr, '.button_minus')
			},

			success: function (response) {
				var res = context.attributeData
				res.push(response)
				context.attributeData = res
				context.loaded = true
				progress.deleteProgress()
			},
			error: function () {
				progress.deleteProgress()
			}
		})
	}
}

function addUploadError (attribute, fileName, error) {
	$('#' + attribute + '__error-block').removeClass('hidden-element').append('<li><p style=\'color: blue\'>' + fileName + '</p>: ' + error + '</li>')
	$('#' + attribute + '__error-block').scrollTop($('#' + attribute + '__error-block')[0].scrollHeight)
}
